import axios from 'axios';
import { COUNTERS_LAMBDA_URL } from '~/constants/config';
import { encodeQuery, referrer } from '~/modules/common/utils/routingUtils';
/**
 * Increase view count with sending request to hit endpoint
 * @param {Object Ref} article Article Object
 */
export const sendOnedioSRVHit = (article, cfct) => {
  const _id = article.value?._id;
  const queryParams = encodeQuery({ key: `article:${_id}`, referrer });
  _id &&
    axios.get(`${COUNTERS_LAMBDA_URL}/hit${queryParams}`, {
      withCredentials: true,
      credentials: 'include',
      headers: cfct ? { 'x-cf-ct': cfct } : {},
    });
};

/**
 * Onedio panel counter
 * @param {String} url Article Redirect Url
 */
export const sendOnedioPanelCounter = (url) => {
  // TODO: Need sentry later
  // const { $sentry } = useContext();
  if (!url) return;
  url = url.replace('http://', 'https://');
  axios.get(url).catch(() => {
    // $sentry.captureException(error);
  });
};
